import { addIndex, filter, map } from "ramda";

export const mapIndexed = <T, U>(fn: (item: T, index: number) => U, items: T[]): U[] => addIndex<T, U>(map)(fn)(items);

export const filterIndexed = <T>(fn: (item: T, index: number) => boolean, items: T[]): T[] =>
  addIndex<T>(filter)(fn)(items);
